// round up a number to x places
export default function roundNumber(num, length) { 
  var number = Math.round(num * Math.pow(10, length)) / Math.pow(10, length)
  return number
}